import { HTTP } from "../../../../services/api-service.js";
import commonObj from "../../../../services/common.js";
var common = new commonObj();
var baseUrl = common.baseURL;
var tableName = "PxCls";

const priceClassStore = {
  namespaced: true,
  state: {
    totalItem: 0,
    q: {
      tableNeedQuery: tableName,
      isOuterJoin: false,
      searchCriteria: "",
      orderBy: "",
      take: 1000000,
      skip: 0
    },
    currentSelectedPage: 0
  },
  actions: {
    getAllPriceClass({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/qgl/listvalue", state.q)
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    savePriceClass({ commit }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(
          baseUrl + "/mm/save",
          JSON.stringify({
            type: tableName,
            modelList: param.priceClassModel,
            option: param.option
          })
        )
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    exportFile({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/mm/export", state.q, { responseType: "blob" })
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    }
  }
};
export default priceClassStore;
